import curry from "../../lib/core/functional/curry";

const FOLLOWING_CLASS = " rm-following";

const renderModule = curry(function renderModule({ h }, _context, {}, _altLoader) {
    function Module({ toggleFollow, isLoggedIn, following }) {
        return (
            <a
                onClick={toggleFollow}
                class="color-inherit"
                href={isLoggedIn ? "javascript:;" : "/login"}
                ariaLabel={following ? 'Unfollow author' : 'Follow author'}
            >
                <span
                    class={`follow-button-label follow-button-label--follow${
                        following ? FOLLOWING_CLASS : ""
                    }`}
                >
                    Follow
                </span>
                <span
                    class={`follow-button-label follow-button-label--unfollow${
                        following ? FOLLOWING_CLASS : ""
                    }`}
                >
                    Unfollow
                </span>
                <span
                    class={`follow-button-label follow-button-label--following${
                        following ? FOLLOWING_CLASS : ""
                    }`}
                >
                    Following
                </span>
            </a>
        );
    }

    return Module;
});

export default function followButton({ preact }) {
    return renderModule(preact);
}
